import {useMemo} from 'react'

import {Industry} from '@mydata/utils/industry'
import {isBefore, parseISO, startOfDay} from 'date-fns'

import {ExpireIndustry} from '$constants/connectExpire'
import {toExpireDays} from '$hooks/query/connect/useConnectExpiresQuery'
import useMyDataExpirationQuery from '$hooks/query/mydata/useMyDataExpirationQuery'
import {ServerDate} from '$utils/date'

import type {ExpiresStatus} from '$share/types/connect/expire'

export const getExpiresInfo = (expiresData?: ExpiresStatus) =>
    expiresData && toExpireDays(expiresData, [ExpireIndustry.INSU])

const useInsuranceExpired = (
    queryOptions: {enabled: boolean} = {
        enabled: true,
    },
) => {
    const {expiresData} = useMyDataExpirationQuery(undefined, queryOptions)
    const expiresInfo = useMemo(() => getExpiresInfo(expiresData), [expiresData])

    const expireInsuranceOrgList = useMemo(
        () =>
            (expiresData?.consents || [])
                .filter((elem) => {
                    const isInsurance = elem.org.industry === Industry.INSU || elem.org.industry === Industry.GINSU
                    const isExpired = elem.endDate ? isBefore(parseISO(elem.endDate), startOfDay(ServerDate())) : false

                    return isInsurance && isExpired
                })
                .map((elem) => elem.org.orgCode),
        [expiresData?.consents],
    )

    return {expired: expiresInfo?.expired, diffDays: expiresInfo?.diffDays ?? null, expireInsuranceOrgList}
}

export default useInsuranceExpired
